module.exports = __webpack_public_path__ + "img/Apply to Universities in just 3 Clicks.a2e9812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Apply to Universities in just 3 Clicks.png
// module id = 1154
// module chunks = 1